import React from 'react';
import { Main, UpperTooltip } from './UpperLineStyles';

export interface UpperLineProps {
    title: string;
    upperText?: string | undefined;
}

export const UpperLine = ({ title, upperText }: UpperLineProps) => {
    return (
        <Main key={title}>
            {title}
            <UpperTooltip>{upperText}</UpperTooltip>
        </Main>
    );
};
